import segmente from '@/resources/enums/segmente'
export default function getSegmentByEZ (erstzulassung) {
  const age = new Date().getFullYear() - erstzulassung
  const segment = Object.values(segmente).find(segment => age >= segment.olderThan)
  if (!segment) return segmente.PC.human
  return segment.human
}
